import styled from "styled-components";
import { WxTitle } from "../..";
import { HomeContent } from "../../../hooks/api/queries/useHome";

interface Props {
  item: HomeContent;
}

export const HomeText = ({ item }: Props) => (
  <Wrapper>
    {(item.title || item.text) && (
      <WxTitle title={item.text} overTitle={item.title} darkMode />
    )}
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 3.75rem;
`;
